import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PartnerScheduledRideCalendarRecordsQueryVariables } from '@/gql/graphql';

export const fetchPartnerScheduledRideCalendarRecords = async ({
  partnerCode,
  phoneNumber,
  startDate,
  endDate,
}: PartnerScheduledRideCalendarRecordsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      partnerCode,
      phoneNumber,
      startDate,
      endDate,
      pagination: {
        offset: 0,
        limit: 0, // return all records from startDate to endDate
      },
    },
    query: graphql(`
      query PartnerScheduledRideCalendarRecords(
        $pagination: PaginationInputType
        $partnerCode: String
        $phoneNumber: String
        $startDate: String
        $endDate: String
      ) {
        partnerScheduledRides(
          pagination: $pagination
          partnerCode: $partnerCode
          phoneNumber: $phoneNumber
          startDate: $startDate
          endDate: $endDate
        ) {
          count
          rows {
            id
            rideName
            canceledAt
            completedAt
            dateTimes
            timeZone
            serviceType
            confirmedAt
            returnTime
          }
        }
      }
    `),
  });

  return response.data.partnerScheduledRides;
};
